import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import styled from '@emotion/styled';

const Spin = ({ spinning = true, children, style, }) => {
    if (!spinning)
        return jsx(Fragment, { children: children });
    return (jsxs(Fragment, { children: [jsx(NestedSpinning, { children: jsx(StyledSpinning, { children: jsx(StyledSpinningInner, {}) }) }), jsx(StyledContainer, Object.assign({ style: style }, { children: children }))] }));
};
const NestedSpinning = styled.div `
  position: relative;
`;
const StyledSpinning = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  display: block;
  width: 100%;
  height: 100%;
  max-height: 400px;
  top: 40px;
  left: calc(50% - 40px);
`;
const StyledSpinningInner = styled.div `
  @keyframes ldio-1ga5p6b2g17 {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  width: 80px;
  height: 80px;
  box-shadow: 0 1.9px 0 0 #3f747e;
  transform-origin: 40px 40px;
  animation: ldio-1ga5p6b2g17 1.27s linear infinite;
  border-radius: 50%;
`;
const StyledContainer = styled.div `
  clear: both;
  opacity: 0.5;
  user-select: none;
  pointer-events: none;
`;

export { Spin as S };
